import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  courseId: null,
  title: '',
  imageUrl: '',
  domain: '',
  category: '',
  progressPercent: 0,
  units: {},
  continueElement: null,
  currentUnitId: null,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const slice = createSlice({
  name: 'courseDetail',
  initialState,
  reducers: {
    courseDetailRequested(state, action) {
      state.courseId = action.payload;
      state.status = 'loading';
      state.error = null;
    },
    courseDetailLoaded(state, action) {
      const { courseId, title, imageUrl, domain, category, progressPercent, units, continueElement, currentUnitId } = action.payload;
      state.courseId = courseId;
      state.title = title;
      state.imageUrl = imageUrl;
      state.domain = domain;
      state.category = category;
      state.progressPercent = progressPercent;
      state.units = units;
      state.continueElement = continueElement;
      state.currentUnitId = currentUnitId;
      state.status = 'succeeded';
      state.error = null;
    },
    courseDetailFailed(state, action) {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to load course';
    },
    courseDetailCleared() {
      return initialState;
    },
  },
});

export const {
  courseDetailRequested,
  courseDetailLoaded,
  courseDetailFailed,
  courseDetailCleared,
} = slice.actions;
export const courseDetailReducer = slice.reducer;
